export default {"src":"/_next/static/media/logo.9d454a32.svg","height":15,"width":230,"blurWidth":0,"blurHeight":0};